import * as React from "react";
import Transscript from "./PivotElements/Transscript/Transscript";
import { PivotItem, Pivot, Text, Stack, IconButton, TooltipHost, Icon } from "office-ui-fabric-react/lib";
import { Spinner } from "office-ui-fabric-react";
import CategoryContainer from "./PivotElements/Category/CategoryContainer";
import KeywordContainer from "./PivotElements/Keyword/KeywordContainer";
import NotesContainer from "./PivotElements/Notes/NotesContainer";
import TtlContainer from "./PivotElements/TTL/TtlContainer";
import { Panel, PanelType } from "office-ui-fabric-react/lib/Panel";
import "./DetailPivot.scss";
import { MyContext } from "../../../context";
import PolicyContainer from "./PivotElements/Compliance/PolicyContainer";
import FieldsContainer from "./PivotElements/Fields/FieldsContainer";
import MetadataList from "./PivotElements/Metadata/MetadataList";
import _ from "lodash";
import * as Query from "./PivotElements/Compliance/PolicyContainerQuery";
import { mutationPerformManualMuting, queryGetEntry } from "./../../../queries/queryRecordings";
import AIQualityManagementResult from './PivotElements/QualityManagement/AIQualityManagementResult';
import AIAssistantResults from './PivotElements/AIAssistantResults/AIAssistantResults';
import AIAssistantIcon from '../../ComplianceView/AIAssistant/AIAssistantIcon';
import CleanUp from './PivotElements/CleanUp/CleanUp';
import MailTranscript from './PivotElements/Transscript/MailTranscript';
import CaseManagement from "./PivotElements/CaseManagement/CaseManagement";


export default class DetailPivot extends React.Component {
    static contextType = MyContext;

    constructor(props) {
        super(props);
        this.state = {
            transcriptExpanded: false,
            selectedKey: 0,
            processing: false,
            dataPolicy: null,
            aiPolicyErrors: undefined,
            summarizedInsights: this.props.data.summarizedInsights,
            policyResultAdherence: [],
            loadingPolicy: false,
            graphqlCallPerformPending: false,
        };
    }

    isProcessing = (value) => {
        this.setState({ processing: value });
    };

    componentDidMount() {
        const conversationId = this.props.data.conversationId;
        if (
            (this.props.userRules?.addOnCompliance || this.props.userRules?.license === "10") &&
            (!this.props.userRules?.visibilityDetails || this.props.userRules?.visibilityDetailsAnalytics) &&
            this.props.userRules?.ruleAccess?.complianceResultsAccess
        ) {
            this.setState({ loadingPolicy: true });
            this.props.apol
                .query({
                    query: Query.queryGetPolicyResult,
                    variables: { conversationId },
                })
                .then((result) => {
                    var dataPolicy = null;
                    var aiPolicyErrors = undefined;
                    if (result.data.getPolicyResult !== null && result.data.getPolicyResult.length > 0) {
                        if (!this.props.userRules.ruleAccess.userComplianceAIQuestions) {
                            var dataResult = [];
                            result.data.getPolicyResult.forEach((pol) => {
                                var r = pol.policyResult.filter((polRes) => {
                                    return polRes.type != "AIQuestion";
                                });
                                if (r != null && r.length > 0) {
                                    dataResult.push(pol);
                                }
                            });
                            dataResult = dataResult
                                .filter((policy) => policy.policyResult.length > 0)
                                .sort(function (a, b) {
                                    a.selected - b.selected;
                                });
                            dataPolicy = dataResult.length > 0 ? dataResult : null;
                        } else {
                            //Both, null and "" are falsey, so this yields all items with an error
                            aiPolicyErrors = result.data.getPolicyResult//
                                .filter(res => res.errorMessage != null && res.errorMessage !== '')//
                                .reduce((akku, e) => {
                                    const r = akku ?? {};
                                    r[e.errorMessage] = r[e.errorMessage] ?? [];
                                    r[e.errorMessage].push(e.policy.name)
                                    return r;
                                }, null)


                            dataPolicy = result.data.getPolicyResult
                                .filter((pol) => pol.policyResult.length > 0)
                                .sort(function (a, b) {
                                    a.selected - b.selected;
                                });
                        }
                        this.props.updatePolicyResults(dataPolicy);
                    }
                    let policyK = [];
                    let policyResultAdherence = [];
                    if (dataPolicy !== null) {
                        dataPolicy.forEach((policyRes) => {
                            policyRes.policyResult.forEach((r) => {
                                if (r.type === "Category" || r.type === "PatternDetection") {
                                    policyK.push(
                                        ...r.appearances.map((a) => {
                                            return {
                                                appearances: [a],
                                                name: a.words[0],
                                                hasSearchExactKeywords: false,
                                                isTranscript: true,
                                                fromPolicy: true,
                                                policy: policyRes.policy.name,
                                            };
                                        })
                                    );
                                } else if (r.type === "AdherencePhrase" || r.type === "AIAdherencePhrase") {
                                    policyResultAdherence.push(
                                        ...r.appearances.map((a) => {
                                            return {
                                                appearances: [a],
                                                name: a.words[0],
                                                hasSearchExactKeywords: false,
                                                isTranscript: true,
                                                fromPolicy: true,
                                                policy: policyRes.policy.name,
                                            };
                                        })
                                    );
                                } else if (r.type !== "AIQuestion") {
                                    policyK.push({
                                        appearances: r.appearances,
                                        name: r.name,
                                        hasSearchExactKeywords: false,
                                        isTranscript: true,
                                        fromPolicy: true,
                                        policy: policyRes.policy.name,
                                    });
                                }
                            });
                        });
                    }
                    let keywords = [];
                    if (this.state.summarizedInsights !== null && this.state.summarizedInsights !== undefined)
                        keywords = [...this.state.summarizedInsights.keywords, ...policyK];
                    else keywords = [...policyK];
                    let summarizedInsights = {
                        ...this.state.summarizedInsights,
                        keywords,
                    };
                    this.setState({
                        dataPolicy,
                        aiPolicyErrors,
                        summarizedInsights,
                        policyResultAdherence,
                        loadingPolicy: false,
                    });
                });
        }
    }

    //define perform action here to be able to switch between tabs while this is loading and keep loading state inside cleanup
    performAction = async (conversationId, authorization, callStartMs, tenantId) => {
        this.setState({ graphqlCallPerformPending: true });

        var data = await this.props.apol.mutate({
            mutation: mutationPerformManualMuting,
            refetchQueries: [
                {
                    query: queryGetEntry,
                    variables: { id: conversationId, auth: authorization, callStartMs: callStartMs },
                },
            ],
            variables: {
                conversationId: conversationId,
                tenantId: tenantId,
            },
        });
        this.setState({ graphqlCallPerformPending: false });

        return data;
    };

    getPivotItemLink = (item) => {
        const isSmallScreen = window.innerWidth < 1300;
        let text = "";
        let icon = "";
        switch (item.itemKey) {
            case "transcript": {
                text = this.context.getTranslation("detailContainer", "transcript");
                icon = <Icon iconName="AlignLeft" style={{ marginRight: "5px" }} />;
                break;
            }
            case "fullScreen": {
                text = "";
                icon = <Icon iconName="FullScreen" style={{ marginRight: "5px" }} />;
                break;
            }
            case "policies": {
                text = this.context.getTranslation("detailContainer", "policy");
                icon = <Icon iconName="Shield" style={{ marginRight: "5px" }} />;
                break;
            }
            case "QMresult": {
                text = this.context.getTranslation("compliance", "AIQM");
                icon = <Icon iconName="TrackersMirrored" style={{ marginRight: "5px" }} />;
                break;
            }
            case "category": {
                text = this.context.getTranslation("detailContainer", "category");
                icon = <Icon iconName="PowerBILogo16" style={{ marginRight: "5px" }} />;
                break;
            }
            case "keywords": {
                text = this.context.getTranslation("detailContainer", "keywords");
                icon = <Icon iconName="6PointStar" style={{ marginRight: "5px" }} />;
                break;
            }
            case "note": {
                text = this.context.getTranslation("detailContainer", "notes");
                icon = <Icon iconName="QuickNote" style={{ marginRight: "5px" }} />;
                break;
            }
            case "customFields": {
                text = this.context.getTranslation("detailContainer", "fields");
                icon = <Icon iconName="ClipboardList" style={{ marginRight: "5px" }} />;
                break;
            }
            case "ttl": {
                text = this.context.getTranslation("detailContainer", "ttl");
                icon = <Icon iconName="Settings" style={{ marginRight: "5px" }} />;
                break;
            }
            case "cleanUp": {
                text = this.context.getTranslation("detailContainer", "cleanUp");
                icon = <Icon iconName="RemoveFromShoppingList" style={{ marginRight: "5px" }} />;
                break;
            }
            case "metadata": {
                text = this.context.getTranslation("detailContainer", "metadata");
                icon = <Icon iconName="Table" style={{ marginRight: "5px" }} />;
                break;
            }

            case "aiResult": {
                text = this.context.getTranslation("detailContainer", "AIAssistantResult");
                icon = <AIAssistantIcon style={{ marginRight: "5px", marginBottom: "5px" }} height="16px" color="black" theme={this.props.theme} />;
                break;
            }
            case "caseManagement": {
                text = this.context.getTranslation("detailContainer", "caseManagementTab");
                icon = <Icon iconName="ReportWarning" style={{ marginRight: "5px" }} />;
                break;
            }
        }
        return isSmallScreen ? (
            <TooltipHost content={text}>{icon}</TooltipHost>
        ) : (
            <div>
                {icon}
                <span>{text}</span>
            </div>
        );
    };

    render() {
        return (<MyContext.Consumer>
            {(context) => (
                <div>
                    <Stack horizontal>
                        <Stack.Item style={{ marginTop: "5px", marginRight: "5px" }}>
                            <Stack>
                                {!this.props.isOpen && <IconButton
                                    iconProps={{ iconName: 'ChevronRight' }}
                                    onClick={this.props.open}
                                />}
                                {this.props.isOpen && <IconButton
                                    iconProps={{ iconName: 'ChevronDown' }}
                                    onClick={this.props.close}
                                />}
                            </Stack>
                        </Stack.Item>
                        <h4>{this.context.getTranslation("settings", "ticketDetails")}</h4>
                    </Stack>
                    {this.props.isOpen && <div>
                        {
                            !this.state.loadingPolicy && <Pivot className="pivot pivot--details"
                                onLinkClick={this._expandClicked}
                                selectedKey={`${this.state.selectedKey}`}>
                                {/*TRANSCRIPT*/}
                                {(!this.props.userRules?.visibilityDetails || this.props.userRules?.visibilityDetailsTranscript) &&
                                    <PivotItem
                                        onRenderItemLink={this.getPivotItemLink}
                                        itemKey="transcript"
                                        headerButtonProps={{
                                            'disabled': this.state.processing,
                                            'style': this.state.processing ? { color: "grey" } : {}
                                        }}                >
                                        <div className="ms-Grid-row pivot-item">
                                            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                                                {this.props.data.analyticRemark == "AnalyticLimitReached" &&
                                                    <Text>{this.context.getTranslation("settings", "analyticsCapacityReached")}</Text>}
                                                {this.props.data.analyticRemark == "TranslateLimitReached" &&
                                                    <Text>{this.context.getTranslation("settings", "translateCapacityReached")}</Text>}
                                                {this.props.data.analyticRemark == "TextAnalyticsLimitReached" &&
                                                    <Text>{this.context.getTranslation("settings", "textAnalyticsCapacityReached")}</Text>}
                                                {this.props.data.hasMail ?
                                                    <MailTranscript
                                                        mailInfo={JSON.parse(this.props.data.mailInfo)}
                                                        metaData={this.props.data}
                                                        client={this.props.apol}
                                                        auth={this.props.authorization}
                                                    /> :
                                                    <Transscript
                                                        key="0"
                                                        client={this.props.apol}
                                                        authorization={this.props.authorization}
                                                        listener={this.props.listener}
                                                        sum={this.state.summarizedInsights}
                                                        policyResultAdherence={this.state.policyResultAdherence}
                                                        data={this.props.data.unifiedTranscript}
                                                        user={this.props.data.linkedUser}
                                                        id={this.props.data.id}
                                                        viewType="one2oneView"
                                                        height={this.props.height}
                                                        export={this.props.data}
                                                        isFullScreen={false}
                                                        userRules={this.props.userRules}
                                                        metadata={this.props.data}
                                                        isShared={this.props.isShared}
                                                        transcriptionErrors={this.state.transcriptionErrors}
                                                        aiSummary={this.props.data?.summarizedInsights?.aiSummary}
                                                    />}
                                            </div>
                                        </div>
                                    </PivotItem>
                                }
                                {(!this.props.userRules?.visibilityDetails || this.props.userRules?.visibilityDetailsTranscript) &&
                                    <PivotItem itemKey="fullScreen"
                                        onRenderItemLink={this.getPivotItemLink}
                                        headerButtonProps={{
                                            'disabled': this.state.processing,
                                            'style': this.state.processing ? { color: "grey" } : {}
                                        }}>
                                        <Panel
                                            isOpen={this.state.transcriptExpanded}
                                            onDismiss={this._hideClicked}
                                            isFooterAtBottom={false}
                                            headerText={this.props.data.topic}
                                            headerClassName="panel-header-small"
                                            type={PanelType.smallFluid}
                                        >

                                            {this.props.data.analyticRemark == "AnalyticLimitReached" &&
                                                <Text>{this.context.getTranslation("settings", "analyticsCapacityReached")}</Text>}
                                            {this.props.data.analyticRemark == "TranslateLimitReached" &&
                                                <Text>{this.context.getTranslation("settings", "translateCapacityReached")}</Text>}
                                            {this.props.data.analyticRemark == "TextAnalyticsLimitReached" &&
                                                <Text>{this.context.getTranslation("settings", "textAnalyticsCapacityReached")}</Text>}
                                            <Transscript
                                                key="0"
                                                client={this.props.apol}
                                                authorization={this.props.authorization}
                                                listener={this.props.listener}
                                                sum={this.state.summarizedInsights}
                                                policyResultAdherence={this.state.policyResultAdherence}
                                                data={this.props.data.unifiedTranscript}
                                                user={this.props.data.linkedUser}
                                                id={this.props.data.id}
                                                viewType="one2oneView"
                                                height={window.innerHeight - 110}
                                                export={this.props.data}
                                                isFullScreen={true}
                                                userRules={this.props.userRules}
                                                metadata={this.props.data}
                                                isShared={this.props.isShared}
                                                openedFromFolder={this.props.openedFromFolder}
                                            />

                                        </Panel>
                                    </PivotItem>}

                                {/*POLICY*/}
                                {(this.props.userRules?.addOnCompliance || this.props.userRules?.license === "10") &&
                                    (!this.props.userRules?.visibilityDetails || this.props.userRules?.visibilityDetailsAnalytics) &&
                                    this.props.userRules?.ruleAccess?.complianceResultsAccess && (
                                        <PivotItem
                                            onRenderItemLink={this.getPivotItemLink}
                                            itemKey="policies"
                                            headerButtonProps={{
                                                disabled: this.state.processing,
                                                style: this.state.processing ? { color: "grey" } : {},
                                            }}
                                        >
                                            <div className="pivot-item">
                                                <PolicyContainer
                                                    key="6"
                                                    conversationId={this.props.data.conversationId}
                                                    listener={this.props.listener}
                                                    height={this.props.height}
                                                    theme={this.props.theme}
                                                    apol={this.props.apol}
                                                    userRules={this.props.userRules}
                                                    dataPolicy={this.state.dataPolicy}
                                                    aiCategorizationPolicies={this.props.data.aiCategorizationPolicies}
                                                    aiPolicyErrors={this.state.aiPolicyErrors}
                                                />
                                            </div>
                                        </PivotItem>
                                    )}
                                {(!this.props.userRules?.visibilityDetails || this.props.userRules?.visibilityDetailsQM) &&
                                    this.props.userRules?.addOnQualityManagement &&
                                    this.props.userRules?.ruleAccess?.complianceQMResultsAccess && (
                                        <PivotItem
                                            onRenderItemLink={this.getPivotItemLink}
                                            itemKey="QMresult"
                                            headerButtonProps={{
                                                disabled: this.state.processing,
                                                style: this.state.processing ? { color: "grey" } : {},
                                            }}
                                        >
                                            <div className="pivot-item">
                                                <AIQualityManagementResult
                                                    data={this.props.data}
                                                    theme={this.props.theme}
                                                    userRules={this.props.userRules}
                                                    apol={this.props.apol}
                                                    auth={this.props.authorization}
                                                    isProcessing={this.isProcessing}
                                                    height={this.props.height}
                                                />
                                            </div>
                                        </PivotItem>
                                    )}
                                {(!this.props.userRules?.visibilityDetails || this.props.userRules?.visibilityDetailsAnalytics) &&
                                    ((this.props.isShared && this.props.data.summarizedInsights !== null) || !this.props.isShared) && (
                                        <PivotItem
                                            onRenderItemLink={this.getPivotItemLink}
                                            itemKey="category"
                                            headerButtonProps={{
                                                disabled: this.state.processing,
                                                style: this.state.processing ? { color: "grey" } : {},
                                            }}
                                        >
                                            <div className="pivot-item">
                                                <CategoryContainer key="1" data={this.props.data} listener={this.props.listener} height={this.props.height} />
                                            </div>
                                        </PivotItem>
                                    )}

                                {(!this.props.userRules?.visibilityDetails || this.props.userRules?.visibilityDetailsAnalytics) &&
                                    ((this.props.isShared && this.props.data.summarizedInsights !== null) || !this.props.isShared) && (
                                        <PivotItem
                                            onRenderItemLink={this.getPivotItemLink}
                                            itemKey="keywords"
                                            headerButtonProps={{
                                                disabled: this.state.processing,
                                                style: this.state.processing ? { color: "grey" } : {},
                                            }}
                                        >
                                            <div className="pivot-item">
                                                <KeywordContainer key="3" data={this.props.data} listener={this.props.listener} height={this.props.height} />
                                            </div>
                                        </PivotItem>
                                    )}

                                {(!this.props.userRules?.visibilityDetails || this.props.userRules?.visibilityDetailsNotes) &&
                                    ((this.props.isShared && this.props.data.hasNotes) || !this.props.isShared) && (
                                        <PivotItem
                                            onRenderItemLink={this.getPivotItemLink}
                                            itemKey="note"
                                            headerButtonProps={{
                                                disabled: this.state.processing,
                                                style: this.state.processing ? { color: "grey" } : {},
                                            }}
                                        >
                                            <div className="pivot-item">
                                                <NotesContainer
                                                    key="4"
                                                    client={this.props.apol}
                                                    data={this.props.data}
                                                    authorization={this.props.authorization}
                                                    listener={this.props.listener}
                                                    height={this.props.height}
                                                    isShared={this.props.isShared}
                                                />
                                            </div>
                                        </PivotItem>
                                    )}

                                {this.props.userRules?.ruleAccess?.hasCustomFieldsAccess &&
                                    (!this.props.userRules?.visibilityDetails || this.props.userRules?.visibilityDetailsCustomFields) && (
                                        <PivotItem
                                            itemKey="customFields"
                                            onRenderItemLink={this.getPivotItemLink}
                                            headerButtonProps={{
                                                disabled: this.state.processing,
                                                style: this.state.processing ? { color: "grey" } : {},
                                            }}
                                        >
                                            <div className="pivot-item">
                                                <FieldsContainer
                                                    data={this.props.data}
                                                    authorization={this.props.authorization}
                                                    client={this.props.apol}
                                                    userRules={this.props.userRules}
                                                    isProcessing={this.isProcessing}
                                                />
                                            </div>
                                        </PivotItem>
                                    )}

                                {((!this.props.userRules?.visibilityDetails || this.props.userRules?.visibilityDetailsTTL) && !this.props.isShared) &&
                                    <PivotItem
                                        itemKey="ttl"
                                        onRenderItemLink={this.getPivotItemLink}
                                        headerButtonProps={{
                                            'disabled': this.state.processing,
                                            'style': this.state.processing ? { color: "grey" } : {}
                                        }}>


                                        <div className="pivot-item">
                                            <TtlContainer key="5"
                                                data={this.props.data}
                                                authorization={this.props.authorization}
                                                hidePanel={this.props.hidePanel}
                                                client={this.props.apol}
                                                listener={this.props.listener}
                                                isProcessing={this.isProcessing}
                                                refreshFolderList={this.props.refreshFolderList}
                                                userRules={this.props.userRules}
                                                legacyConversationSafe={this.props.data.conversationSafe && (this.props.data.conversationSafeFolders?.length ?? 0) == 0}
                                            />
                                        </div>


                                    </PivotItem>}
                                {((!this.props.userRules?.visibilityDetails || this.props.userRules?.visibilityCleanUp) && !this.props.isShared) &&
                                    <PivotItem
                                        itemKey="cleanUp"
                                        onRenderItemLink={this.getPivotItemLink}
                                        headerButtonProps={{
                                            'disabled': this.state.processing || this._disableCleanUpTab(),
                                            'style': this.state.processing || this._disableCleanUpTab() ? { color: "grey" } : {}
                                        }}
                                    >
                                        <div className="pivot-item">
                                            <CleanUp
                                                data={this.props.data}
                                                userRules={this.props.userRules}
                                                client={this.props.apol}
                                                authorization={this.props.authorization}
                                                height={this.props.height}
                                                sliderTimeValue={this.props.sliderTimeValue}
                                                performAction={this.performAction}
                                                graphqlCallPerformPending={this.state.graphqlCallPerformPending}
                                            />
                                        </div>
                                    </PivotItem>}
                                {(!this.props.userRules?.visibilityDetails || this.props.userRules?.visibilityDetailsMetadata) &&
                                    ((this.props.isShared && this.props.data.hasMetadata) || !this.props.isShared) &&
                                    <PivotItem
                                        itemKey="metadata"
                                        onRenderItemLink={this.getPivotItemLink}
                                        headerButtonProps={{
                                            'disabled': this.state.processing,
                                            'style': this.state.processing ? { color: "grey" } : {}
                                        }}
                                    >
                                        <div className="pivot-item">
                                            <MetadataList data={this.props.data} userRules={this.props.userRules} client={this.props.apol} authorization={this.props.authorization} />
                                        </div>
                                    </PivotItem>}
                                {this.props.userRules?.ruleAccess?.userComplianceAIAssistant && (!this.props.userRules?.visibilityDetails || this.props.userRules?.visibilityDetailsAIAssistantHistory) && (
                                    <PivotItem
                                        onRenderItemLink={this.getPivotItemLink}
                                        itemKey="aiResult"
                                        headerButtonProps={{
                                            'disabled': this.state.processing,
                                            'style': this.state.processing ? { color: "grey" } : {}
                                        }}                >
                                        <div className="ms-Grid-row pivot-item">
                                            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                                                <AIAssistantResults
                                                    theme={this.props.theme}
                                                    metadata={this.props.data}
                                                    height={this.props.height}
                                                >
                                                </AIAssistantResults>
                                            </div>
                                        </div>
                                    </PivotItem>)
                                }
                                {this.props.userRules?.addOnCaseManagement && this.props.userRules?.ruleAccess?.userSafe != "No" &&
                                    (<PivotItem
                                        onRenderItemLink={this.getPivotItemLink}
                                        itemKey="caseManagement"
                                        headerButtonProps={{
                                            disabled: this.state.processing,
                                            style: this.state.processing ? { color: "grey" } : {},
                                        }}
                                    >
                                        <div className="ms-Grid-row pivot-item">
                                            <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
                                                <CaseManagement
                                                    theme={this.props.theme}
                                                    client={this.props.apol}
                                                    data={this.props.data}
                                                    authorization={this.props.authorization}
                                                    height={this.props.height}
                                                    conversationId={this.props.data.conversationId}
                                                    userRules={this.props.userRules}
                                                    isProcessing={this.isProcessing}
                                                    refreshFolderList={this.props.refreshFolderList}
                                                ></CaseManagement>
                                            </div>
                                        </div>
                                    </PivotItem>)}
                            </Pivot>
                        }
                        {this.state.loadingPolicy && <Spinner label={context.getTranslation("common", "loading")} ariaLive="assertive" labelPosition="top" />}

                    </div>}
                </div>
            )
            }

        </MyContext.Consumer>
        );
    }

    // Disable the CleanUp tab if there is no recording in the transcript
    _disableCleanUpTab = () => {
        return !this.props.data?.unifiedTranscript?.transcript?.some((item) => item.type === "rec");
    };

    _expandClicked = (item) => {
        this.setState({ selectedKey: item.props.itemKey, transcriptExpanded: true });
        this.setState({ transcriptExpanded: true });
    };
    _hideClicked = () => {
        this.setState({ selectedKey: "transcript", transcriptExpanded: false });
    };
}
